'use client';

import { useEffect, useRef } from 'react';

import AutoLogoutBanner from 'corgi/auto-logout-banner/components/AutoLogoutBanner';
import { Flex } from 'corgi/common/components/Flex';
import { AUTO_LOGOUT_BANNER_Z_INDEX } from 'corgi/common/constants/z-index';

export const LogoutBanner = () => {
  const bannerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const bannerElement = bannerRef.current;
    if (!bannerElement) return;

    const updateHeight = () => {
      const height = bannerElement.offsetHeight;
      if (height > 0) {
        document.documentElement.setAttribute('data-auto-logout-banner-height', String(height));
      }
    };

    updateHeight();

    const resizeObserver = new ResizeObserver(updateHeight);
    resizeObserver.observe(bannerElement);

    return () => {
      resizeObserver.disconnect();
      document.documentElement.setAttribute('data-auto-logout-banner-height', '0');
    };
  }, []);

  return (
    <Flex
      ref={bannerRef}
      position="sticky"
      themeTop="sp_0"
      zIndex={AUTO_LOGOUT_BANNER_Z_INDEX}
      padding="sp_0"
      width="100%"
      boxSizing="border-box"
    >
      <AutoLogoutBanner />
    </Flex>
  );
};
